// extracted by mini-css-extract-plugin
module.exports = {"container":"partnerCard_container__TwL8n","name":"partnerCard_name__DDYKR","timezone":"partnerCard_timezone__3RVCo"};